import { render, staticRenderFns } from "./SearchCasamento.vue?vue&type=template&id=30c6cf70&"
import script from "./SearchCasamento.vue?vue&type=script&lang=js&"
export * from "./SearchCasamento.vue?vue&type=script&lang=js&"
import style0 from "./SearchCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports